import type { ReactElement } from 'react';
import { downloadCsv, type CsvColumn } from '../../../lib/csv.js';

interface ExportCsvButtonProps<T> {
  filename: string;
  rows: ReadonlyArray<T>;
  columns: ReadonlyArray<CsvColumn<T>>;
  disabled?: boolean;
}

/** Botón genérico de export CSV: serializa `rows` con `columns` y descarga. */
export function ExportCsvButton<T>({
  filename,
  rows,
  columns,
  disabled,
}: ExportCsvButtonProps<T>): ReactElement {
  return (
    <button
      type="button"
      className="chip"
      onClick={() => downloadCsv(filename, rows, columns)}
      disabled={disabled || rows.length === 0}
      data-testid="export-csv"
      title={rows.length === 0 ? 'Sin datos para exportar' : `Exportar ${rows.length} filas`}
    >
      ↓ CSV
    </button>
  );
}
